import { Button, Checkbox, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader'
import { useNavigate } from 'react-router-dom';
import { getClientesAgora, getEstados, getOpcionesTareas } from '../../../services/apis';
import CircleIcon from '@mui/icons-material/Circle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import { FormCrearTipoTarea } from '../../proyectos/tareas/FormCrearTipoTarea';
import { OpcionesMenuFunc } from '../../../utils/componentes-utiles/OpcionesMenuFunc';
import { FormCrearCliente } from '../../rrhh/FormCrearCliente';
import { FormEditarTipoTarea } from '../../proyectos/tareas/FormEditarTipoTarea';

export const GestionAgora = () => {

    const Navigate = useNavigate();

    const [loaded, setLoaded] = useState(false);
    const [tiposDeTarea, setTiposDeTarea] = useState([]);
    const [opcionesTipoTareas, setOpcionesTipoTareas] = useState([]);
    const [openCrearTipos, setOpenCrearTipos] = useState(false);
    const [opClientesAgora, setOpClientesAgora] = useState([]);
    const [opcionesTareas, setOpcionesTareas] = useState([]);
    const [formCliente, setFormCliente] = useState(false);
    const [openEditarTipos, setOpenEditarTipos] = useState(false);

    const cargarOpcionesTareas = async () => {
        try {
            const response = await getOpcionesTareas("104");
            console.log(response);
            let temp = response.data.slice(1);
            setOpcionesTareas(temp);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 3:
                setFormCliente(true);
                break;
            // Lógica para la opción 3

            default:
                console.log("Lógica para una opción desconocida ");

                // Lógica para una opción desconocida
                break;
        }
    }

    const cargarEstados = async () => {
        try {
            const response = await getEstados();
            // setEstados(response.data.estados);
            setTiposDeTarea(response.data.tipostarea);
            iterarTiposTarea(response.data.tipostarea);


        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }
    }

    const iterarTiposTarea = (data) => {
        try {
            const tmp = [...data];
            const newTmp = [
                // Proyecto por defecto
                ...tmp.map((item) => ({
                    label: item.nombre,
                    value: item.id
                }))
            ];
            setOpcionesTipoTareas(newTmp);
            // console.log("Proyectos:", newTmp);
            // let tipotareaseleccionado = newTmp.filter(opcion => data.id == opcion.value);
            // console.log("Tipo Tarea:", opcionesTipoTareas);

            // setTipoTarea(tipotareaseleccionado[0]);

            setLoaded(true)
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const cargarClientesAgpra = async () => {
        try {
            const response = await getClientesAgora();
            iterarClientesAgora(response.data);

        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const iterarClientesAgora = (data) => {
        try {
            const tmp = [...data];
            const newTmp = tmp.map((item) => ({
                label: item.nombre,
                value: item.id
            }));

            setOpClientesAgora(newTmp);

            // Seleccionar proyecto si se encuentra el ID
        } catch (error) {
            console.error("Error al cargar proyectos:", error);
        }
    };

    useEffect(() => {
        cargarOpcionesTareas();
        cargarClientesAgpra();
        cargarEstados();
    }, [])


    return (

        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="start"
            xs={12}
            sx={{ display: loaded ? 'flex' : 'none' }}
        >
            <SubHeader titulo={'Gestion Agora'}></SubHeader>


            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                xs={6}
            >

                <Typography variant='h5' gutterBottom>
                    Tipos de tareas
                </Typography>
                <Grid
                    container
                    direction="column"
                    justifyContent="space-evenly"
                    alignItems="center"
                    xs={12}
                    gap={2}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-evenly"
                        alignItems="center"
                        xs={12}
                    >
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                color='primary'
                                onClick={() => setOpenCrearTipos(true)}
                                startIcon={<AddCircleIcon />}
                                sx={{ mb: 2 }}
                            >
                                Crear Tipo de Tarea
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                color='primary'
                                onClick={() => setOpenEditarTipos(true)}
                                startIcon={<EditIcon />}
                                sx={{ mb: 2 }}
                            >
                                Modo Edicion
                            </Button>
                        </Grid>
                    </Grid>

                    {tiposDeTarea.map((tipoTarea) => (
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            xs={11}
                            key={tipoTarea.id}
                            className='fichaje-card'
                            sx={{ boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', p: 2 }}
                        >
                            <Typography variant='h6'>
                                {tipoTarea.nombre}&nbsp;
                            </Typography>
                            <CircleIcon
                                style={{
                                    color: `${tipoTarea.color}`,
                                    marginLeft: 1,
                                    marginRight: 1,
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>

            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                xs={6}
            >
                <Typography variant='h5' gutterBottom>
                    Clientes Agora
                </Typography>

                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={12}
                    gap={2}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-evenly"
                        alignItems="center"
                        xs={12}
                    >
                        <OpcionesMenuFunc handleEvent={handleEvent} opciones={opcionesTareas} />

                    </Grid>
                    {opClientesAgora.map((cliente) => (
                        <Grid
                            item
                            xs={12}
                            className='fichaje-card'
                            sx={{ boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', p: 2 }}
                        >
                            <Typography variant='h6'>
                                {cliente.label}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Grid>


            <FormCrearTipoTarea open={openCrearTipos} setOpen={setOpenCrearTipos} cargarEstados={cargarEstados}></FormCrearTipoTarea>
            <FormCrearCliente open={formCliente} setOpen={setFormCliente} />
            <FormEditarTipoTarea open={openEditarTipos} setOpen={setOpenEditarTipos} tiposDeTarea={tiposDeTarea} cargarEstados={cargarEstados} opcionesTipoTareas={opcionesTipoTareas} setOpcionesTipoTareas={setOpcionesTipoTareas}></FormEditarTipoTarea>

        </Grid>
    )
}
